// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  disabledPrivilegesChecker: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

export const apiConfig = {
  baseUrl: 'https://idoqa-api.rolsoft.dev/api/',
  // baseUrl: 'http://localhost:3000/api/',
  DEFAULT_CONTENT_TYPE: 'multipart/form-data',
  DEFAULT_RESPONSE_TYPE: 'json',
  WITH_CREDENTIALS: false,
  IS_APP: true,
};

export const supportedLanguages = [
  { text: 'Español', value: 'es', img: '' } /*,
  { text: 'English', value: 'en', img: '' }*/,
];

export const defaultImageBlank = '/assets/images/icono.PNG';
export const defaultVideoBlank = '/assets/images/video-play-button.png';

export const SystemStagesDef = {
  receive_and_validate: 1,
  classify_and_value: 2,
  committee: 3,
  development: 4,
  finalize: 5,
  categorize: 6,
  evaluate: 7,
  technical_analysis: 8,
  budget: 9,
  financial_analysis: 10,
  new_idea: 11,
  seti: 12,
  continuity: 13,
};

export const SystemProcessesDef = {
  main: 1,
  initial: 2,
  technology: 3,
  technology_li: 4,
  technology_hi: 5,
  no_new_idea: 6,
  no_new_idea_li: 7,
  no_new_idea_hi: 8,
};

export const SystemNewIdeaCodeDef = {
  yes: 1,
  no: 2,
};

export const SystemContinuityCodeDef = {
  yes: 1,
  no: 2,
};

export const SystemRequirePilotCodeDef = {
  yes: 1,
  no: 2,
};

export const SystemBusinessCaseCodeDef = {
  yes: 1,
  no: 2,
};

export const SystemSetiCodeDef = {
  approved: 1,
  rejected: 2,
  planned: 3,
  sent: 4,
  inReview: 5,
};

export const SystemCategoryFourDef = {
  high: 1,
  low: 2,
};

export const SystemCategoryTwoDef = {
  innovation: 1,
  continuous_improvement: 2,
};

export const defaultLanguage = 'es';

export const userStateRouting = true;

export const appShareLink = 'https://rolsoft.co';
export const appRateLinkAndroid = 'market://details?id=<package_name>';
export const appRateLinkiOS =
  'itms-apps://itunes.apple.com/us/app/domainsicle-domain-name-search/id511364723?ls=1&mt=8';

export const defaultProfileImage = '/assets/avatar.png';

export const IdeaImpactDef = {
  high: 1,
  medium: 2,
  //low: 3
};

export const IdeaStatusDef = {
  done: 1, //usada
  accepted: 2, //usada
  development: 3, //usada
  end_request: 4, //usada
  draft: 5, //usada
  approved: 6, //usada
  rejected: 7, //usada
  postposed: 8, //usada
  sent: 9, //usada
  active: 10,
  close: 11,
  archived: 12,
};

export const IdeaTypesDef = {
  incremental: 1,
  breakout: 2,
  breakthrough: 3,
};

export const IdeaUrgencyDef = {
  high: 1,
  medium: 2,
  low: 3,
};

export const NotificationItemDef = {
  idea: 1,
  reward: 2,
};

export const IdeaProcessStageStatusDef = {
  rejected: 1,
  accepted: 2,
  postposed: 3,
  end_request: 4,
  done: 5,
  development: 6,
  evaluating_viability: 7,
  started: 8,
};

export const NotificationActionDef = {
  rejected_idea: 1,
  rewarded_idea: 2,
  approved_reward: 3,
  rejected_reward: 4,
  new_idea: 5,
};

export const PayrollTypeDef = {
  leadership: 1,
  director: 2,
  default: 3, // trabajador normal
  admin: 4,
};

export const RewardStatusDef = {
  created: 1,
  pending: 2,
  executed: 3,
  rejected: 4,
  approved: 5,
};

export const AdminStatusDef = {
  enable: 1,
  disable: 2,
};

export const PollStatusDef = {
  enable: 1,
  disable: 2,
};

export const GoalStatusDef = {
  enable: 1,
  disable: 2,
};

export const TestimonialStatusDef = {
  enable: 1,
  disable: 2,
};

export const CategoryTwoStatusDef = {
  enable: 1,
  disable: 2,
};

export const CategoryThreeStatusDef = {
  enable: 1,
  disable: 2,
};

export const ReactionStatusDef = {
  enable: 1,
  disable: 2,
};

export const PayrollAccountStatusDef = {
  enable: 1,
  disable: 2,
};

export const ClientStatusDef = {
  created: 1,
  waiting_approval: 2,
  suspended: 3,
  active: 4,
};

export const DirectorStatusDef = {
  created: 1,
  waiting_approval: 2,
  suspended: 3,
  active: 4,
};

export const LeadershipStatusDef = {
  created: 1,
  waiting_approval: 2,
  suspended: 3,
  active: 4,
};

export const PointTypeDef = {
  participation: 1,
  post_evaluation: 2,
};

export const SupportMaterialStatusDef = {
  enabled: 1,
  disabled: 2,
};

export const SupportMaterialTypeDef = {
  link: 'link',
  attachment: 'attachment',
};

export const AgreementStatusDef = {
  enable: 1,
  disable: 2,
};

export const StatsDataviewTypeDef = {
  indicators: 'indicators',
  chart_horizontal_bar: 'chart_horizontal_bar',
  chart_line: 'chart_line',
  chart: 'chart',
  progress_bar: 'progress_bar',
};

export const PrivilegesActionsDef = {
  view: 1,
  create: 2,
  edit: 3,
  delete: 4,
};

export const PrivilegesItemTypeDef = {
  idea_board: 2,
  idea_box: 3,
  committee: 4,
  success_stories: 5,
  award_requests: 6,
  users: 7,
  statistics: 8,
  idea_goals: 9,
  testimonials: 10,
  support_material: 11,
  material_statistics: 12,
  stay_statistics: 13,
  award_types: 14,
  surveys: 15,
  idea_types: 16,
  idea_scopes: 17,
  reactions: 18,
  administrators: 19,
};

export const PrivilegesItemTypeNameDef = {
  idea_board: 'idea_board',
  idea_box: 'idea_box',
  committee: 'committee',
  success_stories: 'success_stories',
  award_requests: 'award_requests',
  users: 'users',
  statistics: 'statistics',
  idea_goals: 'idea_goals',
  testimonials: 'testimonials',
  support_material: 'support_material',
  material_statistics: 'material_statistics',
  stay_statistics: 'stay_statistics',
  award_types: 'award_types',
  surveys: 'surveys',
  idea_types: 'idea_types',
  idea_scopes: 'idea_scopes',
  reactions: 'reactions',
  administrators: 'administrators',
};

export const IdeaMapLocations = [
  {
    id: 1,
    classes: 'leftRight l1',
    style: 'top: 30.8%;left: 78.2%;',
    name: 'Barrio cívico - HSE',
  },
  {
    id: 2,
    classes: 'leftRight l2',
    style: 'top: 49.5%;left: 57.8%;',
    name: 'Mina',
  },
  {
    id: 3,
    classes: 'leftRight l3',
    style: 'top: 40.4%;left: 83.3%;',
    name: 'Planta',
  },
  {
    id: 4,
    classes: 'leftRight l4',
    style: 'top: 36.8%;left: 53.5%;',
    name: 'Barrio cívico - Servicios generales',
  },
  {
    id: 5,
    classes: 'leftRight l5',
    style: 'top: 32.5%;left: 61.7%;',
    name: 'Barrio cívico - Casino',
  },
  {
    id: 6,
    classes: 'leftRight l6',
    style: 'top: 35.5%;left: 77.9%;',
    name: 'Barrio cívico - Policlínico',
  },
  {
    id: 7,
    classes: 'leftRight l7',
    style: 'top: 52.6%;left: 65.8%;',
    name: 'Taller de camiones',
  }, ///////////////
  {
    id: 8,
    classes: 'leftRight l8',
    style: 'top: 50%;left: 50%;display:none;', // no está
    name: 'Planta',
  },
  {
    id: 9,
    classes: 'leftRight l9',
    style: 'top: 80.9%;left: 13.0%;',
    name: 'Campamento - Geología y exploraciones',
  },
  {
    id: 10,
    classes: 'leftRight l10',
    style: 'top: 78.5%;left: 25.8%;',
    name: 'Campamento - HSE',
  },
  {
    id: 11,
    classes: 'leftRight l11',
    style: 'top: 76.5%;left: 50.0%;',
    name: 'Campamento - Servicios generales',
  },
  {
    id: 12,
    classes: 'leftRight l11',
    style: 'top: 4.5%;left: 49.0%;',
    name: 'Pozo 1',
  },
  {
    id: 13,
    classes: 'leftRight l11',
    style: 'top: 1.0%;left: 30.5%;',
    name: 'Pozo 2',
  },
  {
    id: 14,
    classes: 'leftRight l11',
    style: 'top: 9.0%;left: 36.5%;',
    name: 'Botadero Norte',
  },
  {
    id: 15,
    classes: 'leftRight l11',
    style: 'top: 7.8%;left: 83.0%;',
    name: 'Botadero Sur',
  },
  {
    id: 16,
    classes: 'leftRight l11',
    style: 'top: 12.5%;left: 91.4%;',
    name: 'Planta de filtros',
  },
  {
    id: 17,
    classes: 'leftRight l11',
    style: 'top: 20.4%;left: 21.5%;',
    name: 'Brecha Principal',
  },
  {
    id: 18,
    classes: 'leftRight l11',
    style: 'top: 18.1%;left: 70.1%;',
    name: 'Relaves',
  },
  {
    id: 19,
    classes: 'leftRight l11',
    style: 'top: 25.5%;left: 56.5%;',
    name: 'Stockpile Mina',
  },
  {
    id: 20,
    classes: 'leftRight l11',
    style: 'top: 30.0%;left: 41.3%;',
    name: 'Agua Amarga',
  },

  {
    id: 21,
    classes: 'leftRight l11',
    style: 'top: 29.7%;left: 55.0%;',
    name: 'Barrio cívico',
  },
  {
    id: 22,
    classes: 'leftRight l11',
    style: 'top: 34.9%;left: 59.0%;',
    name: 'Barrio cívico - RRHH',
  },
  {
    id: 23,
    classes: 'leftRight l11',
    style: 'top: 33.1%;left: 92.3%;',
    name: 'Taller Vehículos Livianos',
  },
  {
    id: 24,
    classes: 'leftRight l11',
    style: 'top: 38.6%;left: 42.3%;',
    name: 'Taller de Mantenimiento',
  },
  {
    id: 25,
    classes: 'leftRight l11',
    style: 'top: 34.8%;left: 41.7%;',
    name: 'Chancador Primario',
  },
  {
    id: 26,
    classes: 'leftRight l11',
    style: 'top: 48.7%;left: 86.4%;',
    name: 'Salares Norte',
  },
  {
    id: 27,
    classes: 'leftRight l11',
    style: 'top: 71.0%;left: 19.1%;',
    name: 'Campamento',
  },
  {
    id: 28,
    classes: 'leftRight l11',
    style: 'top: 74%;left: 23.6%;',
    name: 'Campamento - Casino',
  },
  {
    id: 29,
    classes: 'leftRight l11',
    style: 'top: 76.0%;left: 17.7%;',
    name: 'Campamento - Sala de recreación',
  },
  {
    id: 30,
    classes: 'leftRight l11',
    style: 'top: 83.5%;left: 22.5%;',
    name: 'Campamento - Loguera',
  },
  {
    id: 31,
    classes: 'leftRight l11',
    style: 'top: 74.9%;left: 42.5%;',
    name: 'Campamento - Pabellones',
  },
  {
    id: 31,
    classes: 'leftRight l11',
    style: 'top: 86.0%;left: 26.3%;',
    name: 'Campamento - Pabellones',
  },
  {
    id: 32,
    classes: 'leftRight l11',
    style: 'top: 82.5%;left: 38.4%;',
    name: 'Campamento - Kiosko',
  },
  {
    id: 33,
    classes: 'leftRight l11',
    style: 'top: 84.8%;left: 52.2%;',
    name: 'Campamento - Canchas de Fútbol',
  },
  {
    id: 34,
    classes: 'leftRight l11',
    style: 'top: 83.0%;left: 58.1%;',
    name: 'Campamento - Estacionamiento de buses',
  },
  {
    id: 35,
    classes: 'leftRight l11',
    style: 'top: 81.0%;left: 49.5%;',
    name: 'Campamento - Policlinico',
  },
  {
    id: 36,
    classes: 'leftRight l11',
    style: 'top: 78.5%;left: 43.0%;',
    name: 'Campamento - RRHH',
  },
];
